import React from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogSubTitle,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../ui/alert-dialog";
import { cn } from "../../../lib/utils";
import { X } from "lucide-react";

function BaseModal({
  icon,
  iconPosition = 'top',
  title = "title",
  subtitle = "",
  trigger = undefined,
  triggerAsChild = false,
  triggerWrapperClassName = "",
  initiallyOpen = true,
  footerElements,
  children,
  actionButtonText = "Continuar",
  showActionButton = true,
  actionButtonClassName = "",
  actionButtonVariant = "submit",
}) {
  const [isOpen, setIsOpen] = React.useState(initiallyOpen);

  React.useEffect(() => {
    setIsOpen(initiallyOpen);
  }, [initiallyOpen]);

  React.useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        document.body.style.pointerEvents = "";
      }, 100);
    }
  }, [isOpen]);

  function handleCloseEvent() {
    setIsOpen(false);
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      {!!trigger && 
        <AlertDialogTrigger 
          className={cn([triggerWrapperClassName])} 
          asChild={triggerAsChild}
        >{trigger}</AlertDialogTrigger>
      }
      <AlertDialogContent
        handleMouseDownOnOverlay={handleCloseEvent}
        onEscapeKeyDown={handleCloseEvent}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <AlertDialogHeader>
          {icon && iconPosition === 'top' && <div className="text-center text-3xl mt-2">{icon}</div>}
          <AlertDialogTitle className={cn([icon && iconPosition === 'top' ? 'pt-0' : ''])}>{title}</AlertDialogTitle>
          {subtitle && <AlertDialogSubTitle>{subtitle}</AlertDialogSubTitle>}
          {icon && iconPosition === 'bottom' && <div className="text-center text-3xl">{icon}</div>}
        </AlertDialogHeader>
        <AlertDialogDescription>{children}</AlertDialogDescription>
        <AlertDialogFooter>
          {footerElements}
          {showActionButton && (
            <AlertDialogAction variant={actionButtonVariant} className={actionButtonClassName} onClick={() => setIsOpen(false)}>
              {actionButtonText}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
        <X size={20} className="absolute top-5 right-4 cursor-pointer" onClick={handleCloseEvent} />
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default BaseModal;
